import { alpha } from '@mui/material/styles';
import { palette } from '../global/palette';
import type { ComponentOverride } from '../types';

export const MuiCheckbox: ComponentOverride<'MuiCheckbox'> = {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        padding: 6,
        margin: '-1px 2px -1px 0',
        color: palette.grey[500],
        '&$checked': {
          '&.Mui-focusVisible': {
            backgroundColor: alpha(palette.primary.main, 0.1),
          },
          '&.MuiSvgIcon': {
            color: palette.error.main,
            backgroundColor: palette.error.main,
          },
        },
        '&.Mui-focusVisible': {
          backgroundColor: alpha(palette.grey[500], 0.1),
        },
      },
      indeterminate: {
        color: palette.primary.main,
      },
      colorPrimary: {
        '&:hover': {
          backgroundColor: alpha(palette.grey[500], 0.1),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent',
          },
        },
        '&:active': {
          backgroundColor: alpha(palette.primary.main, 0.1),
        },
        '&$checked': {
          color: palette.primary.main,
          '&.MuiSvgIcon': {
            color: palette.error.main,
            backgroundColor: palette.error.main,
          },
          '&:hover': {
            backgroundColor: alpha(palette.primary.main, 0.1),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
              backgroundColor: 'transparent',
            },
          },
          '&:active': {
            backgroundColor: alpha(palette.primary.main, 0.1),
          },
        },
        '&.Mui-disabled': {
          color: palette.grey[400],
        },
      },
    },
    defaultProps: {
      color: 'primary',
    },
  },
};
